import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { Tree } from "@lhd/types";
import { notification } from "antd";

export const useFetchBranches = () => {
  const companyId = getCompanyId();

  return useQuery(
    [QUERY_NAME.BRANCHES, companyId],
    () =>
      axios({
        method: "get",
        url: `${SERVICES.COMPANIES}/${companyId}/tree`,
        params: {
          model_name: "branch",
        },
      }).then((res) => (res.data as Tree[]) || []),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!companyId,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
};

export const useUpdateBranches = () => {
  const companyId = getCompanyId();
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload, deleteIds }: any) =>
      axios({
        method: "put",
        url: `${SERVICES.COMPANIES}/${companyId}/tree`,
        data: {
          data: {
            data: payload,
            delete_ids: deleteIds,
          },
        },
        params: {
          model_name: "branch",
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.BRANCHES]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};
